import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const GestionView: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleOperacion = () => {
    navigate('/gestion/operacion');
  };

  const handleConsumos = () => {
    navigate('/gestion/consumos');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-6">
      {/* Header */}
      <div className="max-w-7xl mx-auto mb-8">
        <h1 className="text-4xl font-bold text-gray-900 mb-2">{t('management.title')}</h1>
        <p className="text-gray-600">
          {t('nav.management')}
        </p>
      </div>

      {/* Contenido Principal */}
      <div className="max-w-7xl mx-auto">
        {/* Grid de Botones */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Card Operación */}
          <button
            onClick={handleOperacion}
            className="group relative bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden hover:scale-105"
          >
            {/* Fondo decorativo */}
            <div className="absolute top-0 right-0 w-40 h-40 bg-gradient-to-br from-blue-400 to-blue-600 opacity-10 rounded-full -mr-20 -mt-20 group-hover:scale-150 transition-transform duration-500" />

            {/* Contenido */}
            <div className="relative p-8 text-left">
              {/* Icono */}
              <div className="mb-6 inline-block p-4 bg-blue-100 rounded-lg group-hover:bg-blue-200 transition-colors">
                <svg
                  className="w-8 h-8 text-blue-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                  />
                </svg>
              </div>

              {/* Titulo y descripción */}
              <h2 className="text-2xl font-bold text-gray-900 mb-2">
                {t('management.operation')}
              </h2>
              <p className="text-gray-600 mb-6">
                {t('management.usage')}
              </p>

              {/* Características */}
              <ul className="space-y-2 mb-6">
                <li className="flex items-center text-sm text-gray-700">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mr-2"></span>
                  {t('management.calendar')}
                </li>
                <li className="flex items-center text-sm text-gray-700">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mr-2"></span>
                  {t('management.usage')}
                </li>
                <li className="flex items-center text-sm text-gray-700">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mr-2"></span>
                  {t('analysis.multi_criteria')}
                </li>
              </ul>

              {/* Botón */}
              <div className="inline-block">
                <span className="inline-block px-6 py-2 bg-blue-600 text-white rounded-lg group-hover:bg-blue-700 transition-colors font-medium">
                  {t('management.operation')} →
                </span>
              </div>
            </div>
          </button>

          {/* Card Consumos */}
          <button
            onClick={handleConsumos}
            className="group relative bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden hover:scale-105"
          >
            {/* Fondo decorativo */}
            <div className="absolute top-0 right-0 w-40 h-40 bg-gradient-to-br from-green-400 to-green-600 opacity-10 rounded-full -mr-20 -mt-20 group-hover:scale-150 transition-transform duration-500" />

            {/* Contenido */}
            <div className="relative p-8 text-left">
              {/* Icono */}
              <div className="mb-6 inline-block p-4 bg-green-100 rounded-lg group-hover:bg-green-200 transition-colors">
                <svg
                  className="w-8 h-8 text-green-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M13 10V3L4 14h7v7l9-11h-7z"
                  />
                </svg>
              </div>

              {/* Titulo y descripción */}
              <h2 className="text-2xl font-bold text-gray-900 mb-2">
                {t('management.consumption')}
              </h2>
              <p className="text-gray-600 mb-6">
                {t('management.fuel')}
              </p>

              {/* Características */}
              <ul className="space-y-2 mb-6">
                <li className="flex items-center text-sm text-gray-700">
                  <span className="w-2 h-2 bg-green-500 rounded-full mr-2"></span>
                  {t('management.consumption')}
                </li>
                <li className="flex items-center text-sm text-gray-700">
                  <span className="w-2 h-2 bg-green-500 rounded-full mr-2"></span>
                  {t('management.fuel')}
                </li>
                <li className="flex items-center text-sm text-gray-700">
                  <span className="w-2 h-2 bg-green-500 rounded-full mr-2"></span>
                  {t('common.total')}
                </li>
              </ul>

              {/* Botón */}
              <div className="inline-block">
                <span className="inline-block px-6 py-2 bg-green-600 text-white rounded-lg group-hover:bg-green-700 transition-colors font-medium">
                  {t('management.consumption')} →
                </span>
              </div>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default GestionView;
